
function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/project/${viewName}`)
            if (!modules.default.options.metaInfo) {
                modules.default.options.metaInfo = { title }
            }
            resolve(modules)
        }, reject, 'project')
    }
}

let routes = [
    {
        name: 'agencyList',
        path: '/ems/agencyList',
        meta: {
            // title: '我的待办'
            title: '待办'
        }
    },
    {
        name: 'informDetail',
        path: '/ems/informDetail',
        meta: {
            title: '公告详情'
        }
    },
    {
        name: 'auditLogList',
        path: '/ems/auditLogList',
        meta: {
            title: '审核日志'
        }
    },
    {
        name: 'operationList',
        path: '/ems/operationList',
        meta: {
            title: '操作信息列表'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/project.js